// acciones
export const INITIALIZE_FORM = 'sessionReducer/INITIALIZE_FORM'
export const SAGA_FETCH_INSTALACION = 'sessionReducer/SAGA_FETCH_INSTALACION'
export const SAGA_FETCH_USUARIO_LOGEADO = 'sessionReducer/SAGA_FETCH_USUARIO_LOGEADO'
export const SAGA_AUTENTICAR_USUARIO = 'sessionReducer/SAGA_AUTENTICAR_USUARIO'
export const SAGA_RESTABLECER_CONTRASENIA = 'sessionReducer/SAGA_RESTABLECER_CONTRASENIA'
export const SAGA_OLVIDO_CONTRASENIA = 'sessionReducer/SAGA_OLVIDO_CONTRASENIA'
export const SAGA_VALIDAR_CODIGO = 'sessionReducer/SAGA_VALIDAR_CODIGO'
export const SAGA_FETCH_IMAGEN_LOGIN  = 'sessionReducer/SAGA_FETCH_IMAGEN_LOGIN'
export const SAGA_LOGOUT_USUARIO = 'sessionReducer/SAGA_LOGOUT_USUARIO'

export const SET_MONTO_COMPRAMINIMA = 'sessionReducer/SET_MONTO_COMPRAMINIMA'
export const SET_CONFIGURACION_DELIVERY = 'sessioReducer/SET_CONFIGURACION_DELIVERY'

export const SAVE_INSTALACION = 'sessionReducer/SAVE_INSTALACION'
export const SAVE_DEFAULT_RESULTADO_AUTENTICACION = 'sessionReducer/SAVE_DEFAULT_RESULTADO_AUTENTICACION'
export const SAVE_RESULTADO_AUTENTICACION = 'sessionReducer/SAVE_RESULTADO_AUTENTICACION'
export const SAVE_USUARIO = 'sessionReducer/SAVE_USUARIO'
export const SAVE_IMAGEN_LOGIN = 'sessionReducer/SAVE_IMAGEN_LOGIN'

export const SET_CLAVE_SUPERVISOR_PICKING = 'sessionReducer/SET_CLAVE_SUPERVISOR_PICKING'
export const SAVE_CLAVE_SUPERVISOR_PICKING = 'sessionReducer/SAVE_CLAVE_SUPERVISOR_PICKING'
// funciones
export const initializeForm = (payload) => ({
    type: INITIALIZE_FORM,
    payload
})

export const sagaFetchInstalacion = (payload) => ({
    type: SAGA_FETCH_INSTALACION,
    payload
})

export const setInstalacion = (payload) => ({
    type: SAVE_INSTALACION,
    payload
})

export const sagaFetchUsuarioLogeado = (payload) => ({
    type: SAGA_FETCH_USUARIO_LOGEADO,
    payload
})

export const sagaAutenticarUsuario = (payload) => ({
    type: SAGA_AUTENTICAR_USUARIO,
    payload
})

export const setDefaultResultadoAutenticacion = (payload) => ({
    type: SAVE_DEFAULT_RESULTADO_AUTENTICACION,
    payload
})

export const setResultadoAutenticacion = (payload) => ({
    type: SAVE_RESULTADO_AUTENTICACION,
    payload
})

export const setUsuario = (payload) => ({
    type: SAVE_USUARIO,
    payload
})

export const sagaRestablecerContrasenia = (payload) => ({
    type: SAGA_RESTABLECER_CONTRASENIA,
    payload
})

export const sagaOlvidoContrasenia = (payload) => ({
    type: SAGA_OLVIDO_CONTRASENIA,
    payload
})

export const sagaValidarCodigo = (payload) => ({
    type: SAGA_VALIDAR_CODIGO,
    payload
})

export const sagaLogOutUsuario = (payload) => ({
    type: SAGA_LOGOUT_USUARIO,
    payload
})

export const initializeFormSession = (payload) => ({
    type: INITIALIZE_FORM,
    payload
})

export const sagaFetchImagenLogin = (payload) =>({
    type: SAGA_FETCH_IMAGEN_LOGIN,
    payload
})

export const setImagenLogin = (payload) => ({
    type: SAVE_IMAGEN_LOGIN,
    payload
})

export const sagaSetMontoCompraMinima = (payload) => ({
    type: SET_MONTO_COMPRAMINIMA,
    payload
})

export const sagaSetConfiguracionDelivery = (payload) => ({
    type: SET_CONFIGURACION_DELIVERY,
    payload
})

export const setNewClaveSupervisor = (payload) => ({
    type: SET_CLAVE_SUPERVISOR_PICKING,
    payload
})

export const saveNewClaveSupervisor = (payload) => ({
    type: SAVE_CLAVE_SUPERVISOR_PICKING,
    payload
})
